import type { Coupon } from '../../../../schema/coupon/entry.js';
import type { Definition } from '../../../../schema/frameworks/entry.js';

type QueryOptionsType = {
  definition: Definition;
};

/**
 * Calculates the price of sportkryss bet.
 *
 * @param coupon Coupon entity
 * @param root0 Object containing dependencies
 * @param root0.definition Product definition
 * @returns Calculated price of sportkryss
 */
export function calculateSportkryssPrice(coupon: Coupon, { definition }: QueryOptionsType): number {
  const week = definition.weeks[coupon.week] ?? 1;
  const sportkryssFactor = definition.sportkryssFactors[coupon.sportkryss] ?? 0;

  const sportkryssPrice = sportkryssFactor * definition.sportkryssBase * week;
  return sportkryssPrice;
}
